import { render, staticRenderFns } from "./ColorPropertyItem.vue?vue&type=template&id=16104aaa&scoped=true"
import script from "./ColorPropertyItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorPropertyItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ColorPropertyItem.vue?vue&type=style&index=0&id=16104aaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16104aaa",
  null
  
)

export default component.exports